import { defineComponent as n, computed as o, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "bd247571-1a2e-4fa9-a8e1-7e139147c817" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#bd247571-1a2e-4fa9-a8e1-7e139147c817)" }, v = { key: 0 }, k = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h512v128l-39.8 130.3L512 384v128H0V384l37.8-124L0 128z"
}, null, -1), p = /* @__PURE__ */ t("path", {
  fill: "#ffda44",
  d: "M0 128h512v256H0z"
}, null, -1), g = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ n({
  __name: "es-variant",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (a(), i("title", v, d(e.flagName), 1)) : f("", !0),
        k,
        p
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=es-variant-b50eeb92.js.map
